import { render, staticRenderFns } from "./GamePausedMenu.vue?vue&type=template&id=2ea7fa6b&scoped=true&"
import script from "./GamePausedMenu.vue?vue&type=script&lang=js&"
export * from "./GamePausedMenu.vue?vue&type=script&lang=js&"
import style0 from "./GamePausedMenu.vue?vue&type=style&index=0&id=2ea7fa6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7fa6b",
  null
  
)

export default component.exports